import React from 'react';

import { UploadNavItem } from '~/backup/shared/components/UploadNavItem';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const BackupLenderGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <GlobalNavRouterLinkItem
        to="/portfolio"
        label="Portfolio"
        icon={<Icon icon="house" />}
      />
      <GlobalNavRouterLinkItem
        to="/strats"
        label="Strats"
        icon={<Icon icon="chart-mixed" />}
      />
      <UploadNavItem />
      <GlobalNavRouterLinkItem
        to="/data-pipeline"
        label="Data Pipeline"
        icon={<Icon icon="share-nodes" />}
      />
    </GlobalNav>
  );
};
